
// popup.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PopupService {
  private showPopup = new BehaviorSubject(false);
  private popupData = new BehaviorSubject<any>(null);

  show$ = this.showPopup.asObservable();
  data$ = this.popupData.asObservable();

  success(message: string) {
    this.popupData.next({ type: 'success', message });
    this.showPopup.next(true);
  }

  error(message: string) {
    this.popupData.next({ type: 'error', message });
    this.showPopup.next(true);
  }

  close() {
    this.showPopup.next(false);
  }
}
